import axiosInstance from '../api/axios';

type InstitutionsParams = {
  displayExamSimulator?: boolean;
  ineditQuestions?: boolean;
};

type ExercisesInstitutionsParams = {
  areasFilter?: any[];
  courseId?: string;
  courseWeekId?: string;
  difficulty?: string[];
  hasVideoResolution?: boolean;
  hasntDone?: boolean;
  simulationType?: string;
  institutionType?: string[];
  year?: string[];
};

export async function getInstitutions(params?: InstitutionsParams) {
  try {
    const response = await axiosInstance.get(`/institutions`, {
      params: {
        ...(params?.displayExamSimulator ? { displayExamSimulator: true } : {}),
        ...(params?.ineditQuestions ? { ineditQuestions: true } : {}),
      },
    });

    const institutions = response.data.map((institution: any) => ({
      label: institution.name,
      value: institution.value,
    }));

    return institutions;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getExercisesInstitutions(params?: ExercisesInstitutionsParams) {
  try {
    const payload: any = {
      areasFilter: params?.areasFilter || [],
      courseId: params?.courseId || '',
      courseWeekId: params?.courseWeekId || '',
      difficulty: params?.difficulty || [],
      hasVideoResolution: params?.hasVideoResolution || false,
      simulationType: params?.simulationType || '',
      excludeAnsweredQuestions: params?.hasntDone || false,
    };

    if (params?.year && params.year.length > 0) {
      payload.year = params.year;
    }

    if (params?.institutionType && params.institutionType.length > 0) {
      payload.institutionType = params.institutionType;
    }

    const response = await axiosInstance.post(`/examsimulator/exercisesByInstitutions`, payload);

    return {
      ok: response.data.ok,
      exercisesQuantity: response.data.exercisesQuantity,
      exercisesByInstitutions: response.data.exercisesByInstitutions.map((institution: any) => ({
        label: `${institution.label}`,
        value: institution.value,
        quantity: institution.quantity,
      })),
    };
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getInstitutionsCourses() {
  try {
    const response = await axiosInstance.get(`/institutionscourses`);

    const institutionsCourses = response.data.map((institutionCourse: any) => ({
      label: institutionCourse.name,
      value: institutionCourse.value,
    }));
    return institutionsCourses;
  } catch (e: any) {
    throw new Error(e);
  }
}

type SubareaInstitutionsParams = {
  slug: string;
  selectedYear?: string[];
  exerciseType?: string | null;
  difficulty?: string[];
  questionOptions?: string[];
  favorite?: boolean;
  unanswered?: boolean;
  rightAnswer?: boolean;
  wrongAnswer?: boolean;
  selectedSubjects?: string[];
};

export async function getSubareaInstitutions(params: SubareaInstitutionsParams) {
  try {
    const response = await axiosInstance.post(`/subareas/${params.slug}/institutions`, {
      selectedYear: params.selectedYear?.length ? params.selectedYear : null,
      exerciseType: params.exerciseType || null,
      difficulty: params.difficulty?.length ? params.difficulty : null,
      questionOptions: params.questionOptions?.length ? params.questionOptions : null,
      favorite: params.favorite || null,
      unanswered: params.unanswered || null,
      rightAnswer: params.rightAnswer || null,
      wrongAnswer: params.wrongAnswer || null,
      subject: params.selectedSubjects?.length ? params.selectedSubjects : null,
    });
    const institutions = response.data.institutions.map((institution: any) => ({
      label: institution.label || institution.name,
      value: institution.value,
    }));

    return institutions;
  } catch (e: any) {
    throw new Error(e);
  }
}
